import moment, { Moment } from 'moment-timezone';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import { LobMailOptions } from './lob-mail-options';
import { CommunicationResponse } from './communication-response';

/** Table item type that could be bill pay check, letter group, statement group, on demand invoice, etc */
    // TODO - refactor parents vs items when DB tables change
export class LobMail
{
    id: number;
    optionId: number;
    batchId: number;
    commActivityId: number;
    createdAt: Moment;
    deletedAt: Moment;
    cancelledAt: Moment;
    createdDisplay: string;
    senderName: string;
    totalCost: number;
    numPages: number;
    lastEvent: string;
    additional: string = null;
    status: string;
    sentCount: number;
    sentIds: number[];
    failedCount: number;
    cancelledCount: number;
    sentToName: string;
    sentToAddress: string;
    trackingNumber: string;
    body: string;

    isBatch: boolean;
    isBatchCompleted: boolean;
    batchCancelled: Moment;

    isCancellable = false;
    isCancelled = false;
    isShowingTimeline = false;

    mailOptions: LobMailOptions = null;
    responses: CommunicationResponse[] = [];

    constructor(lobMail: any) {
        this.id = lobMail.id;
        this.optionId = lobMail.optionId;
        this.commActivityId = lobMail.commActivityId;
        this.senderName = lobMail.senderName || 'System';
        this.status = lobMail.status;
        this.sentCount = lobMail.sentCount;
        this.sentIds = lobMail.sentIds || [];
        this.failedCount = lobMail.failedCount;
        this.cancelledCount = lobMail.cancelledCount;
        this.isBatchCompleted = lobMail.batchCompleted;
        this.body = lobMail.body;
        this.numPages = lobMail.numPages;

        // first, is it coming in as a batch item
        this.isBatch = this.sentCount > 1;

        // calculated or adjusted fields
        const timezone = LegFiJwtService.getTimezone();
        if (lobMail.createdAt) {
            this.createdAt = moment.utc(lobMail.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
            this.createdDisplay = this.createdAt.format('MM-DD-YYYY h:mm a');

            if (!lobMail.cancelledAt) {
                const oneHourAgo = moment()
                        .tz(timezone)
                        .subtract(1, 'hour');
                if (oneHourAgo.isBefore(this.createdAt) && !lobMail.cancelledAt) {
                    this.isCancellable = true;
                }
            }
        }

        if (lobMail.batchCancelled) {
            this.batchCancelled = moment.utc(lobMail.batchCancelled, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
            this.isCancelled = true;
            this.isCancellable = false;
            this.totalCost = 0;
        }

        this.totalCost = lobMail.totalCost;

        if (lobMail.cancelledAt) {
            this.cancelledAt = moment.utc(lobMail.cancelledAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);

            this.isCancelled = true;
            this.isCancellable = false;
            this.totalCost = 0;
        }

        // we only care for sentTo* when not a batch item
        if (!this.isBatch) {
            this.sentToName = lobMail.sentToName;
            this.sentToAddress = lobMail.sentToAddress;
            this.trackingNumber = lobMail.trackingNumber;
        }

        this.lastEvent = lobMail.lastEvent;
        if (this.lastEvent === 'Letter sent via Lob' || this.lastEvent === 'Statement sent via Lob') {
            this.lastEvent = 'Created';
        }

        if (lobMail.lastEvent && lobMail.lastEvent.toLowerCase().search('fail') > -1) {
            this.totalCost = 0;
        }

        if (lobMail.mailOptions) {
            this.mailOptions = new LobMailOptions(lobMail.mailOptions);
        }

        if (lobMail.additional) {
            this.additional = lobMail.additional;
        }

        if (lobMail.responses) {
            this.responses = lobMail.responses.map(r => new CommunicationResponse(r));
        }

        if (this.responses.length) {
            if (this.responses[0].additional) {
                this.additional = this.responses[0].additional;
            }
        }

        // single item left in the batch, so we want to handle it like single lob mail item
        if (!this.isBatch && this.sentIds.length === 1) {
            this.batchId = this.id;
            this.id = this.sentIds[0];
        }
    }
}
